
export function HeroSection() {
  return (
    <section className="relative min-h-screen bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/banners/hero-region-asia.jpg')`
      }}>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 container mx-auto px-6 py-32 lg:py-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Asia - Regional Discoveries
          </h1>
          <p className="text-xl lg:text-2xl text-emerald-400 mb-8 font-medium">
            Explore the diverse cultures and breathtaking landscapes of Asia
          </p>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Asia, the largest continent on Earth, is a land of extraordinary contrasts and endless wonders.
              Covering over 44 million square kilometres and home to nearly 60% of the world's population,
              it stretches from the icy tundras of Siberia to the tropical beaches of Southeast Asia,
              offering every climate zone imaginable.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Its landscapes are as diverse as its cultures—ranging from the snow-capped peaks of the
              Himalayas and the vast Gobi Desert to the fertile plains of the Ganges and the lush rain
              forests of Borneo. Asia is also the cradle of ancient civilisation such as Mesopotamia,
              the Indus Valley, and China, and the birthplace of major religions including Hinduism,
              Buddhism, Islam, and Christianity, making it a true cultural and spiritual hub of the world.
            </p>
            <p className="text-lg leading-relaxed">
              From the bustling metropolises of Tokyo and Singapore to the serene temples of Angkor Wat
              and the pristine beaches of the Maldives, Asia offers experiences that captivate every
              traveler's imagination and create memories that last a lifetime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
